export default {
  methods: {
    computeErrors(searchIn, field, validators) {
      let error = [];
      let validationField = this.$v[searchIn][field] || {};

      if (!validationField.$dirty) return error;

      for (let key in validators) {
        if (!validationField[key]) {
          let val = validators[key];
          if (typeof val === 'string') {
            error.push(this.$t(val));
          } else {
            error.push(this.$t(val.message, val.options));
          }
        }
      }

      if (this.validationErrors[field]) {
        this.validationErrors[field].forEach((row) => {
          error.push(row);
        });
      }

      return error;
    }
  }
};
